<template>
  <vs-popup
    v-bind="$attrs"
    :active="active"
    @update:active="updateActive"
    @close="$emit('close')"
  >
    <div class="modal-slot-content" @click.stop>
      <slot></slot>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'MainModal',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  beforeDestroy() {
    this.$el.style.display = 'none';
  },
  methods: {
    updateActive(value) {
      this.$emit('update:active', value);
    },
  },
};
</script>
